var _rect, _rect2, _rect3, _rect4, _rect5, _line, _rect6, _rect7, _rect8, _line2, _rect9, _rect10, _rect11, _line3, _rect12, _rect13, _rect14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMobileMultimediaPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 335,
  height: 1199,
  viewBox: "0 0 335 1199",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.500977,
  width: 334,
  height: 1198,
  rx: 7.5,
  stroke: "black",
  strokeOpacity: 0.2
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 20.001,
  width: 160,
  height: 23,
  fill: "#E5E5E5"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 63.001,
  width: 100,
  height: 16,
  fill: "#E5E5E5"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 91.001,
  width: 295,
  height: 63,
  fill: "#E5E5E5"
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 166.001,
  width: 295,
  height: 146,
  fill: "#E5E5E5"
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 332.501,
  x2: 20,
  y2: 332.501,
  stroke: "#E5E5E5"
})), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 352.001,
  width: 100,
  height: 16,
  fill: "#E5E5E5"
})), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 380.001,
  width: 295,
  height: 63,
  fill: "#E5E5E5"
})), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 455.001,
  width: 295,
  height: 146,
  fill: "#E5E5E5"
})), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 621.501,
  x2: 20,
  y2: 621.501,
  stroke: "#E5E5E5"
})), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 641.001,
  width: 100,
  height: 16,
  fill: "#E5E5E5"
})), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 669.001,
  width: 295,
  height: 63,
  fill: "#E5E5E5"
})), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 744.001,
  width: 295,
  height: 146,
  fill: "#E5E5E5"
})), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
  x1: 315,
  y1: 910.501,
  x2: 20,
  y2: 910.501,
  stroke: "#E5E5E5"
})), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 930.001,
  width: 100,
  height: 16,
  fill: "#E5E5E5"
})), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 958.001,
  width: 295,
  height: 63,
  fill: "#E5E5E5"
})), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 1033,
  width: 295,
  height: 146,
  fill: "#E5E5E5"
})));
export default SvgMobileMultimediaPlaceholder;